export default "__VITE_ASSET__CerOEvpK__"